import IdentificationNumberBlock from '../../../components/FormComponents/IdentificationNumberBlock';
import { Box, Grid } from '@mui/material';
import { FormInput } from '~/components/FormComponents/FormInput.tsx';
import FormAutocomplete from '~/components/FormComponents/FormAutocomplete.tsx';
import { FormDateInput } from '~/components/FormComponents/FormDateInput.tsx';
import { useFormContext } from 'react-hook-form';
import { TPepEntity } from '~/modules/identification/forms/AdditionalInformation/types.ts';
import { useAddressQuery } from '~/queries/useAddressQuery.ts';
import { styles } from '~/modules/identification/forms/AdditionalInformation/styles.ts';
import FormGridItem from '~/components/FormComponents/FormGridItem';

interface PepDataContentProps {
  pepIndex: number;
  section: string;
  itemIndex: number;
}

export const PepDataContent = ({ pepIndex, section, itemIndex }: PepDataContentProps) => {
  const { countryOptions, nonAgressionCountryOptions } = useAddressQuery();
  const {
    formState: { errors },
  } = useFormContext<{ additionalInformation: TPepEntity[] }>();
  const fieldErrors = errors?.additionalInformation?.[pepIndex];
  const field = `additionalInformation.${pepIndex}.${section}.${itemIndex}`;

  return (
    <Grid container spacing={3}>
      <FormGridItem>
        <FormInput
          name={`${field}.fullName`}
          label="ПІБ"
          placeholder="Введіть повне прізвище, ім'я, по батькові"
          fullWidth
        />
      </FormGridItem>
      <FormGridItem>
        <FormInput
          name={`${field}.pepPosition`}
          label="Посада та категорія РЕР"
          placeholder="Введіть посаду та категорію РЕР"
          fullWidth
        />
      </FormGridItem>
      <IdentificationNumberBlock section={field} />
      <FormGridItem>
        <FormAutocomplete
          name={`${field}.citizenshipCountry`}
          options={countryOptions}
          inputProps={{
            placeholder: 'Оберіть країну громадянства',
          }}
          label="Країна громадянства"
        />
      </FormGridItem>
      <FormGridItem>
        <FormAutocomplete
          name={`${field}.residenceCountry`}
          options={nonAgressionCountryOptions}
          inputProps={{
            placeholder: 'Оберіть країну резидентства',
          }}
          label="Країна резидентства"
        />
      </FormGridItem>
      <FormGridItem>
        <FormDateInput
          name={`${field}.publicFunctionsStartDate`}
          label="Дата початку виконання публічних функцій"
          placeholder="Введіть дату початку виконання публічних функцій"
          isCurrentMaxDate
        />
      </FormGridItem>
      <FormGridItem>
        <FormDateInput
          name={`${field}.publicFunctionsEndDate`}
          label="Дата припинення виконання публічних функцій"
          placeholder="Введіть дату припинення виконання публічних функцій"
          isCurrentMaxDate
        />
      </FormGridItem>
      {typeof fieldErrors === 'string' && <Box sx={styles.textFieldError}>{fieldErrors}</Box>}
    </Grid>
  );
};
